import { action, observable } from 'mobx'
import * as TGOService from '../services/TGOService'
import string from '../utils/string'
import BaseStore from './Base.store'

export const TypeModalEnumTGO = {
  TGO_MODAL: 'TGOModal',
  EDIT_MODAL: 'modalEdit',
  NOVO_MODELO_MODAL: 'novoModal',
}

export const defaultObjView = {
  indicacaoClinica: null,
  tabela: { value: 22, label: 22 },
  codigoTermo: null,
  descricao: null,
  quantidadeSolicitada: 1,
  quantidadeSolicitadaUnidadeServico: 1,
  guiaServicoTgoTussViews: [],
  sujeitoAtencao: null,
  observacao: '',
}
export default class TGOStore extends BaseStore {
  @observable objView = {
    ...defaultObjView,
  }
  @observable accessToken = ''
  @observable loadingButtonImpressao = false
  @observable printing = false
  @observable saving = false
  @observable readOnly = false
  @observable guiaServico = null
  @observable entradaProntuario = null
  @observable cid10SubcategoriaModelo = null

  @observable notification = {
    isOpen: false,
    variant: '',
    message: '',
  }
  @observable tipoListagemSelecionada = 'sugestoes'
  @observable tabela = null
  @observable codigoTermo = null
  @observable descricao = null
  @observable nomeModelo = ''
  @observable observacao = ''
  @observable sugestoes = []
  @observable sugestoesLast = false
  @observable sugestoesPagAtual = 0
  @observable sugestoesLoading = false
  @observable typeModal = ''
  @observable statusListaModelo = 'none'
  @observable salvarModelo = false
  @observable modelos = []
  @observable modelosConfig = []
  @observable modelosPagAtual = 0
  @observable modelosLast = false
  @observable modelosLoading = false
  @observable modelosLoadingModal = false
  @observable statusNovoModelo = true
  @observable idModeloSelecionado = ''
  @observable searchNomeModelo = ''
  @observable pageNumberModelo = 0
  @observable sortDirModelo = 'ASC'
  @observable sortFieldModelo = 'nome'
  @observable statusModelo = undefined
  @observable openModal = false
  @observable isProntuario = false
  @observable indicacaoClinicaTemporaria = null
  @observable guiaServicoTussViewsTemporaria = []
  @observable observacaoTemporaria = ''
  @observable disabledListaLateral = false

  @action async findAllCid10Subcategoria(searchDTO = {}) {
    try {
      const response = await TGOService.findAllCid10Subcategoria(searchDTO)

      let searchCid = searchDTO.search
      const { last, content } = response.data.data.findAllCid10Subcategoria

      const customContent = content.map(c => {
        const searchAdaptado = string.capitalize(searchCid)
        const listaDescricaoAbreviada =
          searchCid === '' ||
          c.descricaoAbreviada.includes(searchCid) ||
          c.descricaoAbreviada.includes(searchAdaptado)

        return {
          ...c,
          value: c.id,
          label: listaDescricaoAbreviada ? c.descricaoAbreviada : `${c.codigo} ${c.descricao}`,
        }
      })

      return {
        last,
        content: customContent,
      }
    } catch (error) {
      throw error
    }
  }

  @action async findAllTussView(
    { search = null, tabela = null, codigo = null, descricao = null, pageableDTO },
    field
  ) {
    try {
      const response = TGOService.findAllTussView({
        search,
        tabela,
        codigo,
        descricao,
        pageableDTO,
      })

      const { last, content } = response.data.data.findAllTussView

      const customContent = content.map(item => ({
        ...item,
        value: item.codigoTermo,
        label: `${item.codigoTermo} - ${item.descricao}`,
      }))

      return {
        last,
        content: customContent,
      }
    } catch (error) {
      throw error
    }
  }

  @action async findAllTuss22ProcedimentoEventoSaude(variables, field) {
    try {
      const response = await TGOService.findAllTuss22ProcedimentoEventoSaude(variables)

      const { last, content } = response.data.data.findAllTuss22ProcedimentoEventoSaude

      const customContent = content.map(item => ({
        ...item,
        value: item[field],
        label: item[field],
      }))

      return {
        last,
        content: customContent,
      }
    } catch (error) {
      throw error
    }
  }

  @action async createGuiaServico(input) {
    try {
      if (!input.sujeitoAtencao?.id) {
        throw new Error('Informe o Paciente')
      }

      if (!input.guiaServicoTgoTussViews?.length) {
        throw new Error('Informe o guia de serviço Tuss')
      }

      let cid10Subcategoria

      if (input.indicacaoClinica) {
        cid10Subcategoria = {
          id: input.indicacaoClinica.value,
        }
      }

      const variables = {
        guiaServicoTgo: {
          cid10Subcategoria,
          sujeitoAtencao: {
            id: input.sujeitoAtencao.id,
          },
          guiaServicoTGOTussViews: input.guiaServicoTgoTussViews.map(item => {
            return {
              ...item,
              localOdontograma: {
                id: item.localOdontograma?.local ?? item.localOdontograma?.id,
              },
              localOdontogramaTipo: item.localOdontograma?.id,
              face: item.face?.label ?? item.face,
            }
          }),
          observacao: input.observacao,
        },
      }

      this.saving = true
      const response = await TGOService.createGuiaServicoTGO(variables)

      if (response.data.errors) {
        throw response.data.errors[0]
      }

      return response.data.data.createGuiaServicoTGO
    } catch (error) {
      this.openNotification(error.message, 'error')
      throw error
    } finally {
      this.saving = false
    }
  }

  @action async findGuiaServicoById(id) {
    try {
      const response = await TGOService.findGuiaServicoById(id)

      if (response.data.errors) {
        throw response.data.errors[0]
      }
      return response.data.data.findByIdGuiaServicoTGO
    } catch (error) {
      throw error
    }
  }

  @action async findGuiaServicoByIdEntradaProntuario(id) {
    try {
      const response = await TGOService.findGuiaServicoByIdEntradaProntuario(id)

      if (response.data.errors) {
        throw response.data.errors[0]
      }

      const { content } = response.data.data

      return content
    } catch (error) {
      throw error
    }
  }

  @action reset() {
    this.guiaServico = null
    this.readOnly = false
    this.objView = {
      ...defaultObjView,
    }
  }

  @action async findAllLocalOdontogramaGeral(variables) {
    const response = await TGOService.findAllLocalOdontogramaGeral(variables)

    if (!response.data.errors) {
      return response.data.data.findAllLocalOdontogramaGeral
    } else {
      throw response.data.errors[0]
    }
  }

  @action async findCodigosDisponiveisTussView({ tabela = null, pageableDTO }) {
    const response = await TGOService.findCodigosDisponiveisTussView({ tabela, pageableDTO })
    const { last, content } = response.data.data.findCodigosDisponiveisTussView
    const customContent = content.map(item => ({
      ...item,
      value: item.codigoTermo,
      label: item.codigoTermo,
    }))
    return { content: customContent, last }
  }

  @action async findAllGuiaServicoTussViewQuantidadeUso({ pageableDTO }) {
    this.sugestoesLoading = true

    const response = await TGOService.findAllGuiaServicoTussViewQuantidadeUso(pageableDTO)
    this.sugestoesLoading = false

    const { content, last } = response.data.data.findAllGuiaServicoTGOTussViewQuantidadeUso
    this.sugestoesLast = last
    this.sugestoes = [...this.sugestoes, ...content]

    return this.sugestoes
  }

  @action async findAllGuiaServicoModelo({ searchDTO = {}, pageableDTO }) {
    this.modelosLoadingModal = true

    TGOService.findAllGuiaServicoModeloTGO({
      searchDTO,
      pageableDTO,
    })
      .then(response => {
        const { content, last } = response.data.data.findAllGuiaServicoModeloTGO

        this.modelosLast = last
        this.modelos = [...this.modelos, ...content]
      })
      .catch(error => {
        throw error
      })
      .finally(() => {
        this.modelosLoadingModal = false
      })

    return this.modelos
  }

  @action async findByIdGuiaServicoModelo(id) {
    try {
      const response = await TGOService.findGuiaServicoModeloById(id)
      return response.data.data.findGuiaServicoModeloTGOById
    } catch (error) {
      throw error
    }
  }

  @action async createGuiaServicoModelo(input) {
    const variables = {
      guiaServicoModeloTgo: {
        nome: input.nome,
        observacao: input.observacao,
        ativo: input.ativo,
        guiaServicoModeloTgoTussViews: input.guiaServicoModeloTgoTussViews,
        cid10Subcategoria: {
          id: input.indicacaoClinica ?? input.cid10Subcategoria.id,
        },
        quantidadeUso: 0,
      },
    }

    const response = await TGOService.createGuiaServicoModeloTGO(variables)

    if (response.data.errors) {
      throw response.data.errors[0]
    }

    return response
  }

  @action async updateGuiaServicoModelo(input) {
    let cid10Subcategoria

    if (input.indicacaoClinica) {
      cid10Subcategoria = {
        id: input.indicacaoClinica.value,
      }
    }

    const variables = {
      guiaServicoModeloTgo: {
        id: input.id,
        ativo: input.ativo,
        nome: input.nome,
        observacao: input.observacao,
        guiaServicoModeloTgoTussViews: input.guiaServicoModeloTgoTussViews,
        cid10Subcategoria,
      },
    }

    const response = await TGOService.updateGuiaServicoModeloTGO(variables)

    if (response.data.errors) {
      throw response.data.errors[0]
    }

    return response.data.data.updateGuiaServicoModeloTGO
  }

  @action async ativarRegistro(input) {
    return await TGOService.ativarGuiaServicoModeloTGO(input)
  }

  @action async desativarRegistro(input) {
    return await TGOService.inativarGuiaServicoModeloTGO(input)
  }

  @action async registroQuantidadeUso(input) {
    return await TGOService.registroQuantidadeUsoModeloTGO(input)
  }

  @action changeFieldsStore(values) {
    const arrayKey = Object.keys(values)

    arrayKey.forEach(item => {
      this[item] = values[item]
    })
  }

  @action changeFieldsObjViewStore(values) {
    const arrayKey = Object.keys(values)

    arrayKey.forEach(item => {
      this.objView[item] = values[item]
    })
  }

  @action printSigned = async (token, validToken) => {
    const guiaServico = {
      ...(this.guiaServico?.id && { id: this.guiaServico?.id }),
      ...(this.objView?.indicacaoClinica && {
        cid10Subcategoria: {
          id: this.objView?.indicacaoClinica?.value,
        },
      }),
      sujeitoAtencao: {
        id: this.objView?.sujeitoAtencao?.id,
      },
      guiaServicoTgoTussViews: this.objView?.guiaServicoTgoTussViews,
      observacao: this.objView?.observacao,
    }

    const variables = {
      guiaServico,
      ...(!validToken && { tokenAplicativo: token.replace(' ', '') }),
    }

    let response
    let method = ''
    if (guiaServico?.id) {
      response = await TGOService.imprimirAssinadoGuiaServico(variables)
      method = 'imprimirAssinadoGuiaServicoTGO'
    } else {
      response = await TGOService.criarEImprimirGuiaServicoAssinado(variables)
      method = 'criarEImprimirGuiaServicoAssinadoTGO'
    }

    if (response?.data?.errors) {
      throw Error('Falha ao imprimir a guia de serviço')
    } else {
      return response.data.data[method]
    }
  }

  @action resetModelo = () => {
    this.nomeModelo = ''
    this.statusNovoModelo = true
    this.objView.observacao = ''
    this.objView.guiaServicoTgoTussViews = []
    this.objView.indicacaoClinica = null
  }
}
